import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { isUpdatePending, startVersionCheck } from '@/utils/version-check';
import { toast } from '@/shared/hooks/use-toast';
import { ToastAction } from '@/shared/ui/toast';

/**
 * Offer a deployed update on navigation without interrupting the user's work.
 */
export function VersionGate(): null {
  const location = useLocation();
  const notified = useRef(false);

  useEffect(() => {
    startVersionCheck();
  }, []);

  useEffect(() => {
    if (isUpdatePending() && !notified.current) {
      notified.current = true;
      toast({
        title: 'An update is available',
        description: 'Save your work, then refresh when you’re ready.',
        duration: Infinity,
        action: <ToastAction altText="Refresh to load the update" onClick={() => window.location.reload()}>Refresh</ToastAction>,
      });
    }
  }, [location.pathname]);

  return null;
}

export default VersionGate;
